import MxListButtonFilterWithHookForm from "@rf-l1/page/list/MxListButtonFilterWithHookForm";
import usePropertyListFilterModal from "../hooks/usePropertyListFilterModal";

export const PropertyListButtonFilters = () => {
  const { handleOpenModal } = usePropertyListFilterModal();
  return <MxListButtonFilterWithHookForm handleOpenModalFilters={handleOpenModal} />;
};
